import { Col, Divider, Row } from 'antd';
import React from 'react';
import styled from 'styled-components';
import CustomModal from '../../common-components/CustomModal';
import useStore from '../../hooks/useStore';
import { H7CamptonSemiBold22, H8CamptonSemiBold18, SmallGrey12 } from '../../layout/globalFonts';
import ContentStore from '../../stores/ContentStore';
import ModalStore from '../../stores/ModalStore';

enum CmsContent {
  ModalHeader = 'CouldNotLookupLicensePlateModalTop',
  ModalContent = 'CouldNotLookupLicensePlateModalContent',
  ConfirmationButtonText = 'ThisIsTheCorrectLicensePlate',
  GreenLinkText = 'NoLetMeEnterAnotherPlate',
  LicensePlateLabel = 'licensePlate'
}

interface CouldNotLookUpLicensePlateModalProps {
  licensePlate: string;
  onCancel?: () => void;
  onConfirmation?: () => void;
}

const StyledDivider = styled(Divider)`
  height: 1px;
  background-color: #dedede;
`;

const CouldNotLookUpLicensePlateModal: React.FC<CouldNotLookUpLicensePlateModalProps> = ({
  licensePlate,
  onCancel,
  onConfirmation
}) => {
  const { cmsStore } = useStore(ContentStore) as ContentStore;
  const modalStore = useStore(ModalStore) as ModalStore;

  return (
    <CustomModal
      header={cmsStore.getContent(CmsContent.ModalHeader)?.content}
      primaryButtonText={cmsStore.getContent(CmsContent.ConfirmationButtonText)?.content}
      greenLinkText={cmsStore.getContent(CmsContent.GreenLinkText)?.content}
      mobileViewSecondaryButton
      closable
      onCloseClick={() => onCancel && onCancel()}
      onPrimaryButtonClick={() => {
        if (onConfirmation) {
          onConfirmation();
        }
        modalStore.closeModal();
      }}
      onGreenLinkClick={() => {
        if (onCancel) {
          onCancel();
        }
        modalStore.closeModal();
      }}
    >
      <Col>
        <Row justify="center" style={{ marginTop: '10px' }}>
          <H8CamptonSemiBold18>
            {cmsStore.getContent(CmsContent.ModalHeader)?.subText!}
          </H8CamptonSemiBold18>
        </Row>
        <Row justify="center">
          <SmallGrey12>{cmsStore.getContent(CmsContent.LicensePlateLabel)?.content}</SmallGrey12>
        </Row>
        <Row justify="center">
          <H7CamptonSemiBold22>{licensePlate}</H7CamptonSemiBold22>
        </Row>
        <StyledDivider style={{ margin: '20px 0px 40px 0px' }} />
        <Row>{cmsStore.getContent(CmsContent.ModalContent)?.content}</Row>
        <Row justify="center" style={{ margin: '20px' }}>
          {cmsStore.getContent(CmsContent.ModalContent)?.subText}
        </Row>
      </Col>
    </CustomModal>
  );
};

CouldNotLookUpLicensePlateModal.defaultProps = {
  onCancel: undefined,
  onConfirmation: undefined
};

export default CouldNotLookUpLicensePlateModal;
